import LoadingSpinner from "./LoadingSpinner";

const FullScreenLoader = ({ loading }) => {
  if (!loading) return null;

  return <LoadingSpinner text="Loading..." fullscreen />;
};

export default FullScreenLoader;
